module.exports = __webpack_public_path__ + "img/progress-scribble-bar-color4.4a6bc726.gif";